export class DiscountHelper{
  translateTitle = (title, position = '') => {
    var prefix = ''
    const lang = languageHelper.pageLocale
    if (lang == 'en') {
      if (position == 'price_detail') {
        return ' regional coupon'
      }

      if (title == '地域クーポン') {
        return 'Regional coupon'
      }
    }

    if (lang == 'zh-TW') {
      if (title == '地域クーポン' || position == 'price_detail') {
        return '區域優惠券'
      }
    }

    if (position == 'price_detail') {
      prefix = '分の'
    }

    return prefix + title
  }
}

const discountHelper = new DiscountHelper()
export default discountHelper
